export const getColumnValuesSum = (rows, column) => {
  const values = rows.map(row => row[column]);
  return values.reduce((currentSum, nextValue) => {
    const newSum = currentSum + nextValue;
    return newSum;
  }, 0);
};

export const getColumnValuesAverage = (rows, column) => {
  const values = rows.map(row => row[column]);
  const sum = values.reduce((currentSum, nextValue) => {
    const newSum = currentSum + nextValue;
    return newSum;
  }, 0);

  return sum / rows.length;
};

export const getExportFilename = (tableName, format = 'csv') => {
  const timestamp = Date.now ? Date.now() : new Date().getTime();
  return `${tableName}-${timestamp}.${format}`;
};
